(function () {
  'use strict';

  var STORAGE_KEY = 'bhc_popup_v2';
  var DELAY_MS = 8000; // show after 8 seconds

  function alreadyDismissed() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function dismiss(permanent) {
    if (permanent) {
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    }
    var popup = document.getElementById('bhc-email-popup');
    if (popup) {
      popup.classList.remove('bhc-popup--visible');
      setTimeout(function () { popup.style.display = 'none'; }, 400);
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    var form = e.target;
    var email = form.querySelector('input[type="email"]').value;
    if (!email) return;

    form.style.display = 'none';
    var thanks = document.getElementById('bhc-popup-thanks');
    if (thanks) thanks.style.display = 'block';
    // Popup stays open until user clicks ✕ or No Thanks
  }

  function init() {
    if (alreadyDismissed()) return;

    var popup = document.getElementById('bhc-email-popup');
    if (!popup) return;

    var closeBtn = document.getElementById('bhc-popup-close');
    var noThanks = document.getElementById('bhc-popup-no-thanks');
    var form = popup.querySelector('form');

    if (closeBtn) closeBtn.addEventListener('click', function () { dismiss(true); });
    if (noThanks) noThanks.addEventListener('click', function () { dismiss(true); });
    if (form) form.addEventListener('submit', handleSubmit);

    // Show backdrop close
    popup.addEventListener('click', function (e) {
      if (e.target === popup) dismiss(false); // backdrop click — don't permanently dismiss
    });

    // Show after delay
    setTimeout(function () {
      popup.style.display = 'flex';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          popup.classList.add('bhc-popup--visible');
        });
      });
    }, DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
